<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='600px' v-if="validDialog")
        template(v-slot:activator='{ on }')
            v-tooltip(bottom)
                template(v-slot:activator='{ on, attrs }')
                    v-btn.ma-2(fab x-small color="primary" dark v-on='on' @click="shiftDialog()")
                        v-icon mdi-home-switch
                span Switch Organization
        v-card.mx-lg-auto(width="100%")
            v-card-title Switch Customer's Organization
            v-card-text.width-100.height-100
                v-container.mt-8.p7-8.organization-switch-container

                    v-row.d-flex.flex-column.align-center(style="font-size: 16px;")
                        span Current Organization: 
                        span.text-black {{ currentOrganizationName }}

                    v-icon(
                        style="font-size: 75px;"
                        color='primary'
                    ) mdi-arrow-down-thin

                    div(style="width: 100%; max-width: 400px;")
                        v-autocomplete(
                            hide-details
                            :items='availableOrganizations'
                            item-text='organization_name'
                            item-value='organization_id'
                            label='New Organization *'
                            v-model='selectedOrganizationID'
                            outlined
                        )

            v-card-actions.ma-2
                v-spacer
                v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                    v-icon mdi-window-close
                    | Close
                v-btn.ma-2(color="success" ripple :disabled="!validSelected" @click='confirm();')
                    v-icon mdi-content-save
                    | Confirm Switch

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { PrepareSwitchOrganizationForCustomer } from "@/data";

    export default Vue.extend({
        data() {
            return {
                dialog: false,
                selectedOrganizationID: null,
                switchOrganizationManager: null,
            }
        },
        methods: {
            confirm() {
                this.switchOrganizationForCampaignCustomerActive(this.selectedOrganizationID);
                this.shiftDialog();
            },
            prepareSwitchOrganizationForCustomer() {

                if (!this.validCurrentCampaignCustomer) {
                    return;
                }
                
                // Init
                const options = {
                    campaign_customer_active_id: this.campaignCustomerActiveID,
                }

                this.isLoading = true;
                PrepareSwitchOrganizationForCustomer(this.customerID, options).then((response) => {
                    if (response?.Data?.switch_organization_manager?.customer_id > 0) {
                        this.switchOrganizationManager = response?.Data?.switch_organization_manager;
                    }

                    this.isLoading = false;
                });
            },
            shiftDialog() {
                this.dialog = !this.dialog;
            },
        },
        computed: {
            availableOrganizations() {
                return this.switchOrganizationManager?.available_organizations || [];
            },
            campaignCustomerActiveID() {
                return this.currentCampaignCustomer?.campaign_customer_active_id || 0;
            },
            currentOrganizationID() {
                return this.currentCampaignCustomer?.organization_id || 0;
            },
            currentOrganizationName() {
                return this.switchOrganizationManager?.current_organization?.name;
            },
            customerID() {
                return this.currentCampaignCustomer?.customer_id || 0;
            },
            validCurrentCampaignCustomer() {
                return this.campaignCustomerActiveID > 0 && this.customerID > 0;
            },
            validDialog() {
                return this.validCurrentCampaignCustomer && this.validSwitchFunc && this.currentOrganizationID > 0;
            },
            validSelected() {
                return this.selectedOrganizationID > 0;
            },
            validSwitchFunc() {
                return this.switchOrganizationForCampaignCustomerActive !== undefined && this.switchOrganizationForCampaignCustomerActive !== null;
            },
            validSwitchOrganizationManager() {
                return this.switchOrganizationManager?.customer_id > 0;
            },
        },
        props: {
            currentCampaignCustomer: Object,
            switchOrganizationForCampaignCustomerActive: Function,
        },
        components: {
        },
        created() {
            this.prepareSwitchOrganizationForCustomer();
        },
    });
</script>

<style lang="scss" scoped>
    .organization-switch-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
    
    }
    </style>
